import GoalsAdapter from './base';

export default class Subcategory extends GoalsAdapter {
  modelNamePlural = 'subcategories';
}
